// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__aSrje","card":"Card_card__-SwHU","title":"Card_title__A6GVy","banner":"Card_banner__1Y9cv","pill":"Card_pill__oGeUL","chips":"Card_chips__Rxwk7"};